import React from "react";

import ButtonMC from "../../../presentation/components/ButtonMC";
import IconMC from "../../../presentation/components/IconMC";

const StepModalFooter = ({
  onCancel,
  onSave,
  saving = false,
  showSave = true,
  cancelLabel = 'Cancelar',
  saveLabel = 'Guardar'
}) => (
  <div className="tw-flex-shrink-0 tw-border-t tw-bg-white tw-px-12 tw-pb-4 tw-pt-4">
    <div className="tw-flex tw-justify-center tw-gap-6">
      <ButtonMC
        onClick={onCancel}
        variant="GRAY"
        text={cancelLabel}
        className="tw-w-full"
        outlined
        size="medium"
      />
      {showSave && (
        <ButtonMC
          onClick={onSave}
          text={saveLabel}
          className="tw-w-full"
          disabled={saving}
          loading={saving}
          size="medium"
          renderContent={saving ? () => (
            <>
              <IconMC name="spinner" size="base" className="tw-mr-1 tw-animate-spin" />
              {saveLabel}
            </>
          ) : undefined}
        />
      )}
    </div>
  </div>
);

export default StepModalFooter;
